import React, { useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { DomainContext } from './domain-repository/DomainRepository'

function withLang(WrappedComponent) {

  function LangComponent(props) {
    const { i18n } = useTranslation()
    const { setLanguage, language } = useContext(DomainContext)

    useEffect(() => {
      const lang = language || 'en'
      if (i18n.language !== language) {
        i18n.changeLanguage(lang)
        setLanguage(lang)
      }
    }, [language, setLanguage, i18n])

    return <WrappedComponent {...props} />
  }

  return (props) => <LangComponent {...props} />
}

export default withLang